import type { OrganizationEnvironmentKeySetsApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { OrganizationEnvironmentKeysetResponse } from '../../models/organizationEnvironment.model';

export function mapOrganizationEnvironmentKeysetsResponse(
  response: OrganizationEnvironmentKeySetsApi,
): OrganizationEnvironmentKeysetResponse {
  return {
    keysets: response.keysets,
  };
}
